{
  "nl": {
    "question": {
      "actions": {
        "addDocuments": "Voeg document toe",
        "cancel": "Annuleer",
        "createQuestion": "Vraag aanmaken",
        "delete": "Verwijderen",
        "deleteDocuments": "Verwijder documenten",
        "edit": "Bewerken",
        "moveDown": "Naar beneden verplaatsen",
        "moveUp": "Naar boven verplaatsen",
        "new": "Vraag",
        "save": "Opslaan"
      },
      "attributes": {
        "answer": "Antwoord",
        "documents": "Documenten / Afbeeldingen",
        "name": "Vraag",
        "question": "Vraag"
      },
      "labels": {
        "editQuestion": "Wijzigen vraag",
        "newQuestion": "Nieuwe vraag"
      },
      "toasts": {
        "create": "Vraag aangemaakt",
        "delete": "Vraag verwijderd",
        "update": "Vraag gewijzigd"
      },
      "validation": {
        "needAnswer": "Antwoord is een verplicht veld",
        "needQuestion": "Vraag is een verplicht veld"
      }
    }
  }
}
